import Papa from 'papaparse';

import French from '../locales/french';

var curBundle = null;

const Locale = {
  locale() {
    return window.localStorage.locale || 'en';
  },

  setLocale(locale) {
    window.localStorage.locale = locale;
    this.buildBundle();
  },

  localized(string) {
    if (this.locale() === 'en') {
      return string;
    } else if (this.locale() === 'fr') {
      curBundle || this.buildBundle();
      var result = curBundle[string];
      if (result) {
        return result;
      } else {
        console.error(`Missing localization for: "${string}"`);
        return string;
      }
    }
  },

  buildBundle() {
    if (this.locale() === 'fr') {
      let results = Papa.parse(French);

      if (results.errors.length === 0) {
        var newBundle = {}
        results.data.forEach(row => { newBundle[row[0]] = row[1] });
        curBundle = newBundle;
      } else {
        console.log(`Encountered error(s): ${results.errors} while parsing language bundle`);
      }
    }
  }
}

export default Locale;



// WEBPACK FOOTER //
// ./src/models/Locale.js